enum Mutation {
  SET_FILTERS = 'setFilters'
}

export default Mutation;
